import React, { useEffect } from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { faCheckCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ATOAuthSuccess = () => {
  useEffect(() => {
    // Auto-close the window after 3 seconds
    const timer = setTimeout(() => {
      window.close();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    window.close();
  };

  return (
    <Container className="mt-5">
      <div className="text-center">
        <FontAwesomeIcon 
          icon={faCheckCircle} 
          size="4x" 
          className="text-success mb-3" 
        />
        <h2 className="text-success mb-3">ATO Authentication Successful!</h2>
        <Alert variant="success">
          <strong>Success!</strong> You have successfully authenticated with the ATO API.
          <br />
          You can now use live mode for ATO submissions.
        </Alert>
        <p className="text-muted">
          This window will close automatically in a few seconds.
        </p>
        <Button variant="primary" onClick={handleClose}>
          <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
          Close Window
        </Button>
      </div>
    </Container>
  );
};

export default ATOAuthSuccess;
